import React from 'react';
import { formatError, hasError } from '../../utils/formatError';
import {
    Alert,
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Drawer,
    Typography
} from '@mui/material';
import i18n from '../../i18';
import { AssociatedBlockComponent } from '../../components/associated-block';
import { EmptyWalletTransparentBulkIcon } from '../../icons-lib';
import Scrollbar from '../../components/scrollbar';
import { LoadingButton } from '@mui/lab';
import SearchBox from '../../search-box/SearchBox';
export default class AssignPayoutAccountDialog extends React.Component {
    onClose = () => {};
    onSave = () => {};
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: props.dialogOpen || false,
            alertText: '',
            payoutAccountId: props.payoutAccountId || '',
            walletNumber: props.walletNumber || '',
            payoutAccounts: props.payoutAccounts || []
        };
        this.onClose = props.onClose;
        this.onSave = props.onSave;

        this.wrapperRef = React.createRef();
    }
    static getDerivedStateFromProps(props, state) {
        if (props.dialogOpen !== state.dialogOpen) {
            return {
                dialogOpen: props.dialogOpen,
                payoutAccountId: props.payoutAccountId,
                walletNumber: props.walletNumber,
                payoutAccounts: props.payoutAccounts
            };
        }
        return null;
    }
    handleChangePayoutAccountDialogSave(event) {
        const server = this.props.server;
        this.setState({ loading: true });
        server
            .assignPayoutAccount({
                payoutAccountId: this.state.payoutAccountId,
                walletNumber: this.state.walletNumber
            })
            .then((result) => {
                if (!hasError(result)) {
                    this.setState({ loading: false });
                    this.onSave();
                } else {
                    this.setState({
                        loading: false,
                        alertText: formatError(result)
                    });
                }
            });
    }
    render() {
        const { payoutAccounts } = this.state;
        return (
            <Drawer
                open={this.state.dialogOpen}
                onClose={(event) => this.onClose(event)}
                anchor="right"
                ModalProps={{
                    keepMounted: true
                }}
                sx={{
                    "width": { sm: '100%', md: '40%', lg: '30%' },
                    '& .MuiDrawer-paper': {
                        width: { sm: '100%', md: '40%', lg: '30%' },
                        overflow: 'auto',
                        boxSizing: 'border-box'
                    }
                }}
            >
                {' '}
                <DialogTitle>{i18n.t('text.assignPayoutAccount')}</DialogTitle>
                <DialogContent
                    sx={{ padding: 0, minHeight: 400, position: 'relative' }}
                    ref={this.wrapperRef}
                >
                    <Scrollbar
                        sx={{
                            padding: '20px 24px',
                            height: '100vh'
                        }}
                    >
                        <DialogContentText>
                            {this.state.alertText && (
                                <Alert severity="error">
                                    {this.state.alertText}
                                </Alert>
                            )}
                        </DialogContentText>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle1">
                                {i18n.t('columns.walletNumberDetails')}
                            </Typography>
                            <AssociatedBlockComponent
                                icon={<EmptyWalletTransparentBulkIcon />}
                                primaryTitle={i18n.t('columns.walletNumber')}
                                primaryContent={this.state.walletNumber}
                                primaryContentColor={'highlighted'}
                            />
                        </Box>

                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2">
                                {i18n.t('columns.payoutAccount')}
                            </Typography>
                            <SearchBox
                                handleChange={(value) =>
                                    this.setState({ payoutAccountId: value })
                                }
                                serverSearch={true}
                                searchFields={['name']}
                                searchController={'payoutAccounts'}
                                icon={<EmptyWalletTransparentBulkIcon />}
                                translatedLabel={i18n.t(
                                    'columns.payoutAccount'
                                )}
                                multiple={false}
                                value={this.state.payoutAccountId}
                                primaryTitle={i18n.t('columns.name')}
                                primaryKey="name"
                                items={payoutAccounts}
                                wrapperRef={this.wrapperRef}
                                addAssociationLabel={i18n.t(
                                    'buttons.payoutAccountAdd'
                                )}
                                translatedSearchLabel={i18n.t(
                                    'pages.payoutAccounts.title'
                                )}
                            />
                        </Box>
                    </Scrollbar>
                </DialogContent>
                <DialogActions>
                    <Button
                        fullWidth
                        disabled={this.state.loading}
                        color="secondary"
                        variant="outlined"
                        onClick={(event) => this.onClose(event)}
                    >
                        {i18n.t('buttons.cancel')}
                    </Button>
                    <LoadingButton
                        fullWidth
                        color="primary"
                        variant="contained"
                        loading={this.state.loading}
                        onClick={(event) =>
                            this.handleChangePayoutAccountDialogSave(event)
                        }
                    >
                        {i18n.t('buttons.save')}
                    </LoadingButton>
                </DialogActions>
            </Drawer>
        );
    }
}
